import { Skeleton } from '@/components/ui'
import { CreditHistory } from '@/modules/account/components/CreditHistory'
import { WALLET_TITLES } from '@/modules/account/constants'
import {
  useCreditBank,
  useLoadingCreditBank,
} from '@/modules/account/creditBankStore'
import type { Wallet } from '@/modules/account/types'
import { cn } from '@/utils'
import { BreakdownTables } from './BreakdownTables'
import { UsageByDayChart } from './UsageByDayChart'

const HISTORY_COPY: Record<Wallet, string> = {
  pages: 'A record of your past refills and credit usage.',
  screenings: 'A record of your past refills and screening usage.',
}

export function WalletUsageSection({
  wallet,
  className,
}: {
  wallet: Wallet
  className?: string
}) {
  const creditBank = useCreditBank(wallet)
  const isLoading = useLoadingCreditBank(wallet)

  return (
    <section
      aria-labelledby={`${wallet}-usage-heading`}
      className={cn('space-y-6', className)}
    >
      <h2
        id={`${wallet}-usage-heading`}
        className="text-2xl font-semibold tracking-tight"
      >
        {WALLET_TITLES[wallet]}
      </h2>

      {isLoading && !creditBank ? (
        <Skeleton className="h-64 w-full rounded-xl" />
      ) : (
        <>
          <UsageByDayChart entries={creditBank?.entries ?? []} />
          {creditBank?.summary && (
            <BreakdownTables wallet={wallet} summary={creditBank.summary} />
          )}
        </>
      )}

      <div>
        <h3 className="text-lg font-semibold">History</h3>
        <p className="text-muted-foreground max-w-lg text-sm mb-4">
          {HISTORY_COPY[wallet]}
        </p>
        <CreditHistory wallet={wallet} />
      </div>
    </section>
  )
}
